/* Friendly human check on every site form ("Which one is the duck?"). Markup: snippets/ma-animal-check.liquid.
   Reveals the fieldset, asks for the duck or the cow at random, shuffles the tiles, and blocks submit until the right
   animal is chosen. A courtesy check only; Shopify's hCaptcha remains the security layer. */
(function () {
  function setup(box) {
    if (box.dataset.maReady) return;
    box.dataset.maReady = '1';
    var form = box.closest('form');
    if (!form) return;
    var target = Math.random() < 0.5 ? 'duck' : 'cow';
    var row = box.querySelector('.ma-animal__row');
    var tiles = Array.prototype.slice.call(row.children);
    for (var i = tiles.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = tiles[i]; tiles[i] = tiles[j]; tiles[j] = t; }
    tiles.forEach(function (t) { row.appendChild(t); });
    box.querySelector('[data-ma-animal-target]').textContent = target;
    var msg = box.querySelector('[data-ma-animal-msg]');
    var radios = box.querySelectorAll('input[name="ma_animal"]');
    box.hidden = false;

    function chosen() { var c = box.querySelector('input[name="ma_animal"]:checked'); return c ? c.value : ''; }
    function say(text, bad) { msg.textContent = text; box.classList.toggle('is-wrong', !!bad); box.classList.toggle('is-right', !bad && !!text); }

    box.addEventListener('change', function () {
      var v = chosen();
      if (v === target) say('Thanks!', false);
      else say('Not quite. That’s the ' + v + '. Please pick the ' + target + '.', true);
    });
    form.addEventListener('submit', function (e) {
      if (chosen() === target) return;
      e.preventDefault();
      say(chosen() ? 'Not quite. Please pick the ' + target + '.' : 'Please pick the ' + target + ' to continue.', true);
      (box.querySelector('input[name="ma_animal"]:checked') || radios[0]).focus();
    });
  }
  function init() { document.querySelectorAll('[data-ma-animal]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
